import React, { useState } from 'react';
import PortfolioItem from './PortfolioItem';
import styles from './styles.module.scss';
import { PortfolioCardProps, PortfolioNotificationConfig } from './types';
import { ModalType } from './utils/ModalSwitcher';

interface PortfolioListProps {
  portfolios: PortfolioCardProps[] | null | undefined;
  getLabel: (status: string) => string;
  t: (key: string) => string;
  onOpenModal: (type: ModalType, onConfirm?: () => void | Promise<void>) => Promise<boolean>;
  reloadData?: () => Promise<void>;
  onNotificationBanner?: (config: PortfolioNotificationConfig | null) => void;
}

const PortfolioList: React.FC<PortfolioListProps> = ({
  portfolios,
  getLabel,
  t,
  onOpenModal,
  onNotificationBanner
}) => {
  const [openDropdownId, setOpenDropdownId] = useState<string | null>(null);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>(undefined);

  const handleToggle = (portfolioId: string, el: HTMLElement) => {
    if (openDropdownId === portfolioId) {
      setOpenDropdownId(null);
      setAnchorEl(undefined);
    } else {
      setOpenDropdownId(portfolioId);
      setAnchorEl(el);
    }
  };

  const handleClose = () => {
    setOpenDropdownId(null);
    setAnchorEl(undefined);
  };
  const displayForOnlyTwoPortfolios = (portfolios as PortfolioCardProps[])?.length <= 2;
  return (
    <div
      className={`${styles.portfolioCardHorizontal} 
    ${portfolios && portfolios?.length < 3 ? styles.hasThreeItems : ''} 
    ${portfolios && portfolios.length > 3 ? styles.scrollable : styles.evenlySpaced}`}
    >
      {portfolios?.map((portfolio, index) => {
        const portfolioId = portfolio.portfolioId ?? `fallback-${index}`;
        return (
          <PortfolioItem
            key={portfolioId}
            portfolio={portfolio}
            isOpen={openDropdownId === portfolioId}
            anchorEl={anchorEl}
            onToggle={(el) => handleToggle(portfolioId, el)}
            onClose={handleClose}
            getLabel={getLabel}
            t={t}
            isDisplayForOnlyTwoPortfolios={displayForOnlyTwoPortfolios}
            onOpenModal={(type, onConfirm) => onOpenModal(type, onConfirm)}
            onNotificationBanner={onNotificationBanner}
          />
        );
      })}
    </div>
  );
};

export default PortfolioList;
